import * as commonActionTypes from "../shared/commonActionTypes";

export const clearCaseSummaryData = () => {
    return dispatch => {
        dispatch({ type: commonActionTypes.CLEAR_CASE_SUMMARY_DATA });
    };
}